import { CssBaseline, ThemeProvider } from '@material-ui/core';
import React from 'react';
import { theme } from '../../src/theme';

const wrapWithProviders = ({ element }) => (
  <ThemeProvider theme={theme}>
    {element}
    <CssBaseline />
  </ThemeProvider>
);

export default wrapWithProviders;